<script setup lang="ts">
/**
 * PAGE CAGNOTTE — donateurs de la collecte, dans la colonne de GAUCHE sous la
 * bannière (Karim 2026-10-12 : la carte de droite était trop chargée) :
 * avatars, nombre de donateurs et dernier don. La date limite, elle, reste
 * dans la carte de droite.
 */
defineProps<{
  donateurs: Array<{ id: string | number; name?: string | null }>;
  nbDonateurs: number;
  /** « il y a 2 h » — dernier don reçu, s'il est connu. */
  dernierDon?: string | null;
}>();

const initiales = (nom?: string | null) =>
  (nom ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((m) => m.charAt(0).toUpperCase())
    .join("") || "♥";
</script>

<template>
  <div class="flex items-center gap-3">
    <div v-if="donateurs.length" class="flex -space-x-2">
      <span
        v-for="d in donateurs.slice(0, 4)"
        :key="d.id"
        class="w-9 h-9 rounded-full ring-2 ring-white bg-gradient-to-br from-[#dfe7ff] to-[#b9ccff] text-[#0c3097] text-xs flex items-center justify-center"
        style="font-weight: 700 !important"
      >{{ initiales(d.name) }}</span>
    </div>
    <p class="text-[15px] text-gray-600 leading-tight">
      <span class="text-(--color-ink)" style="font-weight: 700 !important">{{ nbDonateurs }}</span>
      {{ $t("campagne.pageCagnotte.donateurs", nbDonateurs) }}
      <span v-if="dernierDon" class="text-gray-400"> · {{ $t("campagne.pageCagnotte.dernierDon", { quand: dernierDon }) }}</span>
    </p>
  </div>
</template>
